import commonEnHK from './common_en-HK'

const membershipEnHK = {
  membership: {
    ...commonEnHK,
  }
}

export default membershipEnHK